import { StrictMode } from "react";
import { flushSync } from "react-dom";
import { createRoot } from "react-dom/client";

import Bridge from "./Bridge";

const rootElement = document.getElementById("root");

if (!rootElement) {
  throw new Error("Root element not found");
}

const root = createRoot(rootElement);

// Forces the initial mount to commit synchronously
flushSync(() => {
  root.render(
    <StrictMode>
      <Bridge />
    </StrictMode>,
  );
});

performance.mark("bridge:render-committed");

performance.measure(
  "bridge:initial-mount",
  "bridge:evaluate",
  "bridge:render-committed",
);

requestAnimationFrame(() => {
  performance.mark("bridge:first-paint");
  performance.measure(
    "bridge:mount-to-paint",
    "bridge:render-committed",
    "bridge:first-paint",
  );
});
